export const getGraphFieldData = (store) => store.catv.fieldData;
export const getGraphChartConfig = (store) => store.catv.chartConfig;
